.logoBlackwing {
  display: block;
  margin: 45vh auto 0;
  width: 240px;
}

.blackwingSeven {
  opacity: 0;
}